<template>
  <LpBakuneDry
    :mens-product-id="BAKUNE_DRY_PRODUCT_IDS.long.mens"
    :womens-product-id="BAKUNE_DRY_PRODUCT_IDS.long.womens"
    :lineup-products="lineupProducts"
  />
</template>

<script setup lang="ts">
import { BAKUNE_DRY_LINEUP_PRODUCTS, BAKUNE_DRY_PRODUCT_IDS } from "~/const/lp"

definePageMeta({ layout: "no-header" })

/**
 * ラインナップ商品の設定
 */
const lineupProducts = BAKUNE_DRY_LINEUP_PRODUCTS.short
</script>
